import { z } from 'zod';

import { EmployeeRole } from '@/common/graphql';

export const EmployeeInfoFilter = z.object({
  managerIds: z.array(z.string()).catch([]),
  jobIds: z.array(z.string()).catch([]),
  team: z.string().nullable().default(null),
  isExactMatch: z.boolean().default(false),
  nationalityIds: z.array(z.string()).catch([]),
  roles: z.array(z.nativeEnum(EmployeeRole)).catch([]),
  managerIncludesAllConnections: z.boolean().default(false),
  hiredDate: z
    .object({
      start: z.string().nullable().default(''),
      end: z.string().nullable().default(''),
    })
    .nullable()
    .optional()
    .catch(null),
  lastWorkingDate: z
    .object({
      start: z.string().nullable().default(''),
      end: z.string().nullable().default(''),
    })
    .nullable()
    .optional()
    .catch(null),
  employmentEndDate: z
    .object({
      start: z.string().nullable().default(''),
      end: z.string().nullable().default(''),
    })
    .nullable()
    .optional()
    .catch(null),
});
export type EmployeeInfoFilterType = z.infer<typeof EmployeeInfoFilter>;
